/**
 * Extract segment name as a plain string.
 */
export function segmentTransform(segment) {
    return segment ? segment.segmentName : undefined;
}
